import * as React from "react";

const PortalContainerCtx = React.createContext<Element | null>(null);

export function PortalContainerProvider({
  container,
  children,
}: {
  container: Element;
  children: React.ReactNode;
}) {
  console.log('[PortalContainerProvider] Providing container:', container);
  return (
    <PortalContainerCtx.Provider value={container}>
      {children}
    </PortalContainerCtx.Provider>
  );
}

export function usePortalContainer() {
  const container = React.useContext(PortalContainerCtx);
  console.log('[usePortalContainer] Returning container:', container);
  return container;
}
